import React, { Component, memo, useState } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CTooltip
} from "@coreui/react";
import ReactDOM from "react-dom";
import { Handle, useStoreState } from "react-flow-renderer";
import {
  RiAddFill,
  RiCheckboxCircleFill,
  RiCheckboxMultipleFill
} from "react-icons/ri";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import { baseDate, baseToDateTimeLocal, formatDate } from "../../utils/date";
import ChooseNodeModal from "../ChooseNodeModal";
import EditNodeModal from "../EditNodeModal";
import ViewNodeModal from "../ViewNodeModal";

const appRoot = document.getElementById("root");

class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        color="danger"
        show={this.props.show}
        centered
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Apagar atividade da trilha</CModalHeader>
        <CModalBody>Deseja apagar a atividade da trilha?</CModalBody>
        <CModalFooter>
          <CButton color="danger" onClick={() => this.props.onDelete()}>
            Confirmar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}

export default memo(
  ({ id, data = {}, selected, isConnectable, xPos, yPos }) => {
    const user = useSelector(state => state.user.user);

    const [showSource, setShowSource] = useState(false);
    const [showTarget, setShowTarget] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [chooseModal, setChooseModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [createActivity, setCreateActivity] = useState(false);
    const [direction, setDirection] = useState("");
    const selectedElements = useStoreState(store => store.selectedElements);
    const opacity = data.doing && !data.active ? 0.7 : 1;

    const showEditModal = () => {
      data.setDrag(false);
      setCreateActivity(false);
      setEditModal(true);
    };

    const showDeleteModal = () => {
      data.setDrag(false);
      setDeleteModal(true);
    };

    const showViewModal = () => {
      data.setDrag(false);
      setViewModal(true);
    };

    const showCreateModal = direction => {
      data.setDrag(false);
      setCreateActivity(true);
      setDirection(direction);
      setEditModal(true);
    };

    const showChooseModal = direction => {
      data.setDrag(false);
      setDirection(direction);
      setChooseModal(true);
    };

    const onCreate = activity => {
      data.setDrag(true);
      setEditModal(false);
      setChooseModal(false);

      data.addElement(
        {
          id: (Math.random() + 1).toString(36).substring(7),
          type: "activity",
          position: {
            x: xPos,
            y: direction === "up" ? yPos - 250 : yPos + 250
          },
          data: {
            temporary: true,
            activity,
            start: null,
            end: null
          }
        },
        id,
        direction
      );
    };

    const onEdit = activity => {
      data.setDrag(true);
      setEditModal(false);
      setChooseModal(false);

      data.editElement({
        id,
        type: "activity",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          activity
        }
      });
    };

    const onDelete = () => {
      setDeleteModal(false);
      data.setDrag(true);

      data.deleteElement(id);
    };

    const onClose = () => {
      data.setDrag(true);
      setEditModal(false);
      setChooseModal(false);
      setDeleteModal(false);
      setViewModal(false);
    };

    const toggleStartDate = () => {
      data.editElement({
        id,
        type: "activity",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          start: data.start ? null : baseDate(new Date())
        }
      });
    };

    const toggleEndDate = () => {
      data.editElement({
        id,
        type: "activity",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          end: data.end ? null : baseDate(new Date())
        }
      });
    };

    const changeStartDate = e => {
      data.editElement({
        id,
        type: "activity",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          start: baseDate(new Date(e.target.value))
        }
      });
    };

    const changeEndDate = e => {
      data.editElement({
        id,
        type: "activity",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          end: baseDate(new Date(e.target.value))
        }
      });
    };

    const executed =
      data.activity?.executions?.length > 0 &&
      data.activity?.executions[0].completion_percentage >= 100;

    const late = data.end && new Date(data.end) < new Date();
    const notStarted = data.start && new Date(data.start) > new Date();

    const onClick = params => {
      if (notStarted) {
        toastr.warning("Atenção", "A atividade ainda não foi iniciada");
        return;
      }

      if (late) {
        toastr.warning("Atenção", "A atividade já encerrou");
        return;
      }

      data.onClick(params);
    };

    return (
      <>
        {deleteModal && (
          <DeleteModal
            show={deleteModal}
            onDelete={onDelete}
            onClose={onClose}
          />
        )}
        {editModal && (
          <EditNodeModal
            show={editModal}
            id={createActivity ? null : data.activity?.id}
            onCreate={onCreate}
            onEdit={onEdit}
            onClose={onClose}
          />
        )}
        {chooseModal && (
          <ChooseNodeModal
            show={chooseModal}
            onSelect={onCreate}
            onClose={onClose}
          />
        )}
        {viewModal && (
          <ViewNodeModal
            show={viewModal}
            id={data.activity?.id}
            onClose={onClose}
          />
        )}
        <Handle
          type="target"
          position="top"
          isConnectable={data.editable && isConnectable}
          style={
            data.editable
              ? {
                  width: 10,
                  height: 10,
                  background: "var(--light)",
                  border: `2px solid ${
                    data.activeInput || data.editable
                      ? "var(--primary)"
                      : "var(--secondary)"
                  }`,
                  transform: "translate(-6px, -6px)"
                }
              : {
                  width: 0,
                  height: 0,
                  background: "transparent",
                  borderColor: "transparent"
                }
          }
          onMouseEnter={() => setShowTarget(true)}
          onMouseLeave={() => setShowTarget(false)}
        >
          {data.editable && (
            <div
              style={{
                width: 10,
                transform: "translate(-2px, -100%)",
                marginTop: "-2px",
                opacity: 1,
                transition: "0.15s ease-in-out"
              }}
              className="bg-light d-flex flex-column align-items-center justify-content-center"
              onClick={e => e.stopPropagation()}
            >
              {(true || showTarget) && (
                <>
                  <CDropdown>
                    <CDropdownToggle
                      color="white"
                      style={{ width: "20px", height: "20px" }}
                      className="rounded-circle p-0 small text-muted d-flex align-items-center justify-content-center card m-0"
                      caret={false}
                    >
                      <RiAddFill size={16} />
                    </CDropdownToggle>
                    <CDropdownMenu placement="top">
                      <CDropdownItem onClick={() => showCreateModal("up")}>
                        Criar nova atividade
                      </CDropdownItem>
                      <CDropdownItem onClick={() => showChooseModal("up")}>
                        Escolher uma atividade
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                  <div
                    className={`${
                      data.activeInput || data.editable
                        ? "bg-primary"
                        : "bg-secondary"
                    }`}
                    style={{ width: 2, height: 10 }}
                  ></div>
                </>
              )}
            </div>
          )}
        </Handle>
        <CCard
          color="white"
          className={`m-0 ${!data.doing && selected ? "shadow-sm" : ""}${
            data.doing ? " hover-shadow" : ""
          }`}
          style={{
            transition: "0.15s ease-in-out",
            opacity,
            width: "200px",
            cursor: data.doing
              ? "pointer"
              : !data.editable
              ? "pointer"
              : undefined
          }}
          onClick={() =>
            data.doing && data.active
              ? onClick(data.activity?.id)
              : !data.doing && !data.editable
              ? showViewModal()
              : null
          }
        >
          <CCardHeader
            className="d-flex align-items-center p-2"
            style={{
              borderBottom:
                (data.activity?.items && data.activity?.items.length > 0) ||
                (data.activity?.currentUsers &&
                  data.activity?.currentUsers.length > 0)
                  ? undefined
                  : 0
            }}
          >
            {executed ? (
              <RiCheckboxCircleFill color="var(--success)" className="mr-2" />
            ) : (
              <RiCheckboxMultipleFill color="var(--primary)" className="mr-2" />
            )}
            <span className="flex-1 text-ellipsis">{data.activity?.name}</span>
            {data.editable && (
              <CDropdown>
                <CDropdownToggle
                  color="white"
                  className=" ml-2 card-header-action remove-caret"
                  style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none"
                  }}
                >
                  <i className="fa fa-ellipsis-v text-muted"></i>
                </CDropdownToggle>
                <CDropdownMenu
                  placement="bottom-start"
                  style={{ cursor: "default" }}
                >
                  {data.activity?.user_id === user.id && (
                    <CDropdownItem onClick={showEditModal}>
                      Editar
                    </CDropdownItem>
                  )}
                  <CDropdownItem onClick={showDeleteModal}>
                    Apagar
                  </CDropdownItem>
                  <CDropdownDivider />
                  <div
                    style={{
                      paddingLeft: "1.25rem",
                      paddingRight: "1.25rem",
                      whiteSpace: "nowrap"
                    }}
                    className="mb-1"
                  >
                    <div className="small text-muted w-100 d-flex justify-content-between">
                      Data de início
                      <a href="#" className="ml-3" onClick={toggleStartDate}>
                        {data.start ? "Remover" : "Adicionar"}
                      </a>
                    </div>
                    {data.start && (
                      <CInput
                        type="datetime-local"
                        className="mt-2 mb-2"
                        value={baseToDateTimeLocal(data.start)}
                        onChange={changeStartDate}
                      />
                    )}
                  </div>
                  <div
                    style={{
                      paddingLeft: "1.25rem",
                      paddingRight: "1.25rem",
                      whiteSpace: "nowrap"
                    }}
                    className="mb-1"
                  >
                    <div className="small text-muted w-100 d-flex justify-content-between">
                      Data de fim
                      <a href="#" className="ml-3" onClick={toggleEndDate}>
                        {data.end ? "Remover" : "Adicionar"}
                      </a>
                    </div>
                    {data.end && (
                      <CInput
                        type="datetime-local"
                        className="mt-2 mb-2"
                        value={baseToDateTimeLocal(data.end)}
                        onChange={changeEndDate}
                      />
                    )}
                  </div>
                </CDropdownMenu>
              </CDropdown>
            )}
          </CCardHeader>
          <CCardBody className="d-flex flex-column align-items-start justify-content-center p-2 small">
            <div
              className={
                !executed && notStarted
                  ? "opacity-half"
                  : !executed && late
                  ? "text-danger"
                  : ""
              }
            >
              <strong>Início: </strong>
              {data.start ? formatDate(data.start) : "Qualquer momento"}
            </div>
            <div
              className={
                !executed && notStarted
                  ? "opacity-half"
                  : !executed && late
                  ? "text-danger"
                  : ""
              }
            >
              <strong>Fim: </strong>
              {data.end ? formatDate(data.end) : "Qualquer momento"}
            </div>
          </CCardBody>
          {data.activity?.items && data.activity?.items.length > 0 && (
            <CCardBody className="d-flex flex-wrap align-items-center justify-content-start px-2 pb-2 pt-0">
              {data.activity.items.map(item => (
                <CTooltip content={item.name}>
                  <div
                    className={`bg-${item.type?.color} rounded-circle d-flex align-items-center justify-content-center`}
                    style={{ width: 20, height: 20, margin: "2px" }}
                  >
                    <i className={`fa fa-${item.type?.icon}`}></i>
                  </div>
                </CTooltip>
              ))}
            </CCardBody>
          )}
          {data.activity?.currentUsers &&
            data.activity?.currentUsers.length > 0 && (
              <CCardFooter
                className="d-flex align-items-center justify-content-start p-2 bg-primary"
                style={{ borderColor: "rgba(0, 0, 0, 0.125)" }}
              >
                {data.activity.currentUsers.map(user => (
                  <img
                    src={
                      URL.img + (user.photo || "uploads/users/profileEmpty.jpg")
                    }
                    className="bg-warning rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: 24,
                      height: 24,
                      border: "2px solid var(--primary)"
                    }}
                  />
                ))}
              </CCardFooter>
            )}
        </CCard>
        <Handle
          type="source"
          position="bottom"
          isConnectable={data.editable && isConnectable}
          style={
            data.editable
              ? {
                  width: 10,
                  height: 10,
                  background: "var(--light)",
                  border: `2px solid ${
                    data.activeOutput || data.editable
                      ? "var(--primary)"
                      : "var(--secondary)"
                  }`,
                  transform: "translate(-6px, 6px)"
                }
              : {
                  width: 0,
                  height: 0,
                  background: "transparent",
                  borderColor: "transparent"
                }
          }
          onMouseEnter={() => setShowSource(true)}
          onMouseLeave={() => setShowSource(false)}
        >
          {data.editable && (
            <div
              style={{
                width: 10,
                transform: "translate(-2px, 8px)",
                opacity: 1,
                transition: "0.15s ease-in-out"
              }}
              className="bg-light d-flex flex-column align-items-center justify-content-center"
              onClick={e => e.stopPropagation()}
            >
              {(true || showSource) && (
                <>
                  <div
                    className={`${
                      data.activeOutput || data.editable
                        ? "bg-primary"
                        : "bg-secondary"
                    }`}
                    style={{ width: 2, height: 10 }}
                  ></div>
                  <CDropdown>
                    <CDropdownToggle
                      color="white"
                      style={{ width: "20px", height: "20px" }}
                      className="rounded-circle p-0 small text-muted d-flex align-items-center justify-content-center card m-0"
                      caret={false}
                    >
                      <RiAddFill size={16} />
                    </CDropdownToggle>
                    <CDropdownMenu placement="bottom">
                      <CDropdownItem onClick={() => showCreateModal("down")}>
                        Criar nova atividade
                      </CDropdownItem>
                      <CDropdownItem onClick={() => showChooseModal("down")}>
                        Escolher uma atividade
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                </>
              )}
            </div>
          )}
        </Handle>
      </>
    );
  }
);
